/**
 * Created by anthony on 6/26/14.
 */
/**
 * Created by anthony on 6/26/14.
 */

var ismangularlib = angular.module('ismAngularLib');
ismangularlib.filter('postal', function () {
    return function (postal) {
        if (!postal) { return ''; }
        var value = postal.toString().trim().replace(/^\+/, '');
        if (value.match(/[^0-9]/)) {
            return postal;
        }
        switch (value.length) {
            case 5:
                return value;
            case 7:
                return value;
            case 9:
                var zip = value.slice(0, 4);
                var plus4 = value.slice(4);
                return zip + '-' + plus4;
                break;
            default:
                return postal;
        }
    };
});
